import { UserRole } from '@lmc/ts-common'
import * as GlobalActions from '../actions/Global'
import { getJSON, postJSON } from '../common/services/api'
import { initialiseAnalytics } from '../common/services/analytics'
import initialiseFirebase from '../common/services/firebase'
import { initialiseIntercom } from '../common/services/intercom'
import { setFirstLogin } from '../common/services/api'
import { initialiseListData } from './Data'
import { history } from '../store'
import { initialiseBirdie } from 'common/services/birdie'
import * as Sentry from '@sentry/react'
import { createMongoAbility } from '@casl/ability'

export function getHomeDetails(id) {
  return (dispatch) => {
    const url = `/api/list/homes/${id}`
    return getJSON({ url })
      .then((res) => {
        dispatch(GlobalActions.setHomeDetails(res.result))
      })
      .catch((err) => {
        console.log(err)
      })
  }
}

export function saveHomeDetails(homeDetails) {
  return (dispatch) => {
    const url = `list/homes/${homeDetails.id}`
    return postJSON({ url, json: homeDetails, method: 'PUT' })
      .then((res) => {
        dispatch(GlobalActions.setHomeDetails(res.result))
      })
      .catch((err) => {
        console.log(err)
      })
  }
}

// Fetch ENV variables, permissions and feature toggles from the backend
export function initialiseAppSession(initResponse, skipAnalytics = false) {
  return async (dispatch) => {
    try {
      const res = initResponse

      const {
        CHARGEBEE_ENV,
        MIXPANEL_TOKEN,
        GA_DOMAIN,
        GA_PROPERTY,
        GTM_ID, // 'GTM-T8QZF3C'
        INTERCOM_APP_ID,
        INTERCOM_HASH,
        FIREBASE_CONFIG,
        FIREBASE_PUBLIC_VAPID_KEY,
        user,
        home,
        homeGroup,
        permissionTemplates
      } = res

			initialiseAnalytics({
        MIXPANEL_TOKEN,
        user,
        home,
        GTM_ID,
        GA_DOMAIN,
        GA_PROPERTY,
      })

      Sentry.setUser({
        id: user.id,
        ip_address: '{{auto}}',
        other: {
          home: user.home,
          role: user.role,
        },
      })

      dispatch(GlobalActions.setGlobalUser({ ...user, privacyOfficer: false }))
      dispatch(GlobalActions.setHomeDetails(home))
      dispatch(GlobalActions.setHomeGroup(homeGroup))
      dispatch(
        GlobalActions.setPermissionTemplates(permissionTemplates),
      )
      dispatch(initialiseListData(user.role)) // Loads all list data

      if (
        home?.features?.pro?.enabled &&
        user.role === UserRole.careHomeAdmin
      ) {
        await initialiseFirebase({
          FIREBASE_CONFIG,
          FIREBASE_PUBLIC_VAPID_KEY,
        })
      }

      if (skipAnalytics) return

      // TODO: import as npm module
      if (global.Chargebee !== undefined && !global.Chargebee.inited) {
        global.Chargebee.init({
          site: CHARGEBEE_ENV, //  isProduction ? 'logmycare' : 'logmycare-test',
        })
      }

      // Check for, then set, first login
      if (!user.firstLogin) setFirstLogin()
      const isOnBoardingScreen =
        history.location.pathname.startsWith('/onboarding')
      if (!isOnBoardingScreen) {
        initialiseIntercom({ INTERCOM_APP_ID, INTERCOM_HASH, user, home })
        initialiseBirdie(user?.name?.first, user?.email, INTERCOM_APP_ID)
      }
    } catch (e) {
      console.log(e)
    }
  }
}

export function initialisePermissions() {
  return async (dispatch) => {
    try {
      const resAbility = await getJSON({ url: '/api/list/carers/me' })

      const ability = resAbility?.data

      const abilityInstance = createMongoAbility(ability?.rules)

      // eslint-disable-next-line object-shorthand
      dispatch(GlobalActions.setAbility(abilityInstance))
    } catch (e) {
      console.log(e)
    }
  }
}
